import gql from 'graphql-tag';

import { executeGqlQuery } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';
import type {
  BackendPerformanceCenterCustomerResourceExist,
  BackendQueryCustomerResourcesExistArgs,
} from 'src/types/backend';

const QUERY = gql`
  query CustomerResourcesExist(
    $customerId: ID!
    $workspaceId: ID
    $inputs: [ResourceDetailsInput!]!
  ) {
    customerResourcesExist(customerId: $customerId, workspaceId: $workspaceId, inputs: $inputs) {
      content
      exist
      type
      id
    }
  }
`;

type Variables = BackendQueryCustomerResourcesExistArgs;
type Result = BackendPerformanceCenterCustomerResourceExist[];

export const checkCustomerResourcesExistence = async (variables: Variables) => {
  const result = await executeGqlQuery({ query: QUERY, variables });
  return getSingleProp<Result>(result.data);
};
